// extracted by mini-css-extract-plugin
module.exports = {"back":"NavigateBack_back__2xDvS","link":"NavigateBack_link__19U60","button":"NavigateBack_button__dZLvY"};